import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface FormGroupProps extends Omit<BoxProps, 'title'> {
  /** Mono uppercase section label, e.g. "Name — you can change it anytime" */
  label?: React.ReactNode
  children: React.ReactNode
}

const Root = styled(Box)({
  background: 'var(--ds-canvas)',
  borderRadius: 'var(--ds-radius-lg)',
  boxShadow: 'var(--ds-shadow-soft)',
  padding: 24,
  marginBottom: 18,
})

const Label = styled('div')({
  fontFamily: 'var(--ds-font-mono)',
  fontSize: 9.5,
  letterSpacing: '0.14em',
  textTransform: 'uppercase',
  color: 'var(--ds-ink-subtle)',
  marginBottom: 14,
})

/** White elevated form section with optional mono label — create/settings field groups. */
export function FormGroup({ label, children, ...rest }: FormGroupProps) {
  return (
    <Root {...rest}>
      {label != null && <Label>{label}</Label>}
      {children}
    </Root>
  )
}
